function hilight(content, query) {
    if (!query) {
        return content;
    }
    return content.replace(new RegExp(query, "gi"), match => {
        return '<span class="highlight-text">' + match + '</span>';
    });
}

export { hilight };
